import type {
  CollectionPageQuery_CatalogCollectionPagesV1Resource_bySlug_elements as CatalogCollectionPage,
  CollectionPageQuery_CatalogCollectionPagesV1Resource_bySlug_elements_courses_elements as CoursesV1,
  CollectionPageQuery_CatalogCollectionPagesV1Resource_bySlug_elements_degrees_elements as DegreesV1,
  CollectionPageQuery_CatalogCollectionPagesV1Resource_bySlug_elements_s12ns_elements as OnDemandSpecializationsV1,
} from 'bundles/collections/components/__generated__/CollectionPageQuery';
import type { org_coursera_ondemand_common_DifficultyLevel as DifficultyLevelType } from 'bundles/collections/components/__generated__/globalTypes';

export type BaseCoursesV1 = Pick<CoursesV1, 'id' | '__typename' | 'level' | 'slug' | 'name'>;

export type BaseOnDemandSpecializationsV1 = Pick<
  OnDemandSpecializationsV1,
  'id' | '__typename' | 'metadata' | 'slug' | 'name'
>;

export type BaseDegreesV1 = Pick<DegreesV1, 'id' | '__typename' | 'slug' | 'name'>;

export const getCollectionItems = ({
  collection,
  s12nsArray,
  coursesArray,
  degreesArray = [],
}: Pick<CatalogCollectionPage, 'collection'> & {
  s12nsArray: Array<BaseOnDemandSpecializationsV1 | null>;
  coursesArray: Array<BaseCoursesV1 | null>;
  degreesArray?: Array<BaseDegreesV1 | null>;
}) => {
  const allCollectionItems = [...coursesArray, ...s12nsArray, ...degreesArray];

  const collectionItems = collection.entries.map((entry) => {
    const matchedCollectionItem = allCollectionItems.find((c) => {
      if (c) {
        return c.id === entry.id;
      } else {
        return false;
      }
    });

    if (!matchedCollectionItem) {
      return null;
    }

    let assignLevel: DifficultyLevelType | null = null;

    if (matchedCollectionItem.__typename === 'OnDemandSpecializationsV1') {
      assignLevel = matchedCollectionItem.metadata.level;
    } else if (matchedCollectionItem.__typename === 'CoursesV1') {
      assignLevel = matchedCollectionItem.level;
    }

    return { ...matchedCollectionItem, level: assignLevel };
  });

  return collectionItems;
};
